import React, { useState } from 'react';

import { Form, Modal } from 'antd';
import { NotificationInstance } from 'antd/lib/notification/interface';

import PhoneInputFormItem from '@controls/phone-input-form-item/phone-input-form-item';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { exception, success } from '@extensions/notification';
import { serverFetch } from '@core/server';

interface IResetPassword {
    phoneNumber: string;
}

interface IResetPasswordProps {
    apiBaseUrl: string | undefined;
    api: NotificationInstance;
    onClose: () => void;
}

const ResetPassword = (props: IResetPasswordProps) => {
    const { apiBaseUrl, api, onClose } = props;

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const d = useAppDispatch();

    const onSave = (entity: IResetPassword) => {
        setLoading(true);

        serverFetch(apiBaseUrl, undefined, 'auth/resetpassword', { method: 'POST', bodyData: entity.phoneNumber })
            .then(() => {
                setLoading(false);

                success(api, `Временный пароль успешно отправлен на номер: ${entity.phoneNumber}`);

                onClose();
            })
            .catch((ex: any) => {
                setLoading(false);
                exception(api, 'Ошибка восстановления пароля', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <Modal
            title='Восстановить пароль по SMS'
            open={true}
            mask={{ closable: false }}
            destroyOnHidden
            onCancel={() => {
                form.resetFields();
                onClose();
            }}
            onOk={() => {
                form.submit();
            }}
            okText='ОК'
            okButtonProps={{ loading: loading, disabled: loading }}
            width={350}
            styles={{
                title: {
                    color: 'var(--main-green)',
                },
            }}
        >
            <Form form={form} layout='vertical' onFinish={onSave} style={{ marginTop: 20, marginBottom: 20 }}>
                <PhoneInputFormItem
                    required
                    value={undefined}
                    name='phoneNumber'
                    requiredMessage='Укажите зарегистрированный в системе номер телефона'
                />
            </Form>
        </Modal>
    );
};

export default ResetPassword;
